export default __webpack_public_path__ + "static/media/youtube_logo.c4107130.svg";